import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { retry, timeout } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SKIP_GLOBAL_LOADING } from '../auth/loading.interceptor';
import { SKIP_ERROR_REDIRECT } from '../auth/error.interceptor';

@Injectable()
export class HttpUtilityService {
  appAPIBaseURL = environment.apiEndpoint;

  requestTimeout = environment.requestTimeout;

  constructor(private readonly http: HttpClient) {}

  get<T>(
    endpoint: string,
    params?: HttpParams,
    retryCount = 2,
    skipGlobalLoading = false,
    skipErrorRedirect = false,
  ): Observable<T> {
    return this.http
      .get<T>(`${this.appAPIBaseURL}${endpoint}`, {
        params,
        context: new HttpContext()
          .set(SKIP_GLOBAL_LOADING, skipGlobalLoading)
          .set(SKIP_ERROR_REDIRECT, skipErrorRedirect),
      })
      .pipe(timeout(this.requestTimeout), retry(retryCount));
  }

  post<T>(
    endpoint: string,
    body: unknown,
    retryCount = 2,
    skipGlobalLoading = false,
  ): Observable<T> {
    return this.http
      .post<T>(`${this.appAPIBaseURL}${endpoint}`, body, {
        context: new HttpContext().set(SKIP_GLOBAL_LOADING, skipGlobalLoading),
      })
      .pipe(timeout(this.requestTimeout), retry(retryCount));
  }

  postBlob(endpoint: string, body: unknown): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.appAPIBaseURL}${endpoint}`, body, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  getBlob(endpoint: string, skipGlobalLoading = false): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.appAPIBaseURL}${endpoint}`, {
      observe: 'response',
      responseType: 'blob',
      context: new HttpContext().set(SKIP_GLOBAL_LOADING, skipGlobalLoading),
    });
  }

  put<T>(endpoint: string, body: unknown): Observable<T> {
    return this.http.put<T>(`${this.appAPIBaseURL}${endpoint}`, body);
  }

  patch<T>(endpoint: string, body: unknown): Observable<T> {
    return this.http.patch<T>(`${this.appAPIBaseURL}${endpoint}`, body);
  }

  delete<T>(endpoint: string): Observable<T> {
    return this.http.delete<T>(`${this.appAPIBaseURL}${endpoint}`);
  }

  public getBy<T>(endPoint: string, data: T) {
    let path = `${this.appAPIBaseURL}/${endPoint}`;
    return this.http.request('GET', path, {
      body: data,
      observe: 'response',
    });
  }

  public getById<T>(endPoint: string, id: T) {
    let path = `${this.appAPIBaseURL}/${endPoint}/${id}`;
    return this.http.request('GET', path, {
      observe: 'response',
    });
  }

  public deleteByPayload<T>(url: string, data: any) {
    let apiPath = `${this.appAPIBaseURL}/${url}`;
    return this.http.request('DELETE', apiPath, {
      body: data,
      observe: 'response',
    });
  }
}
